<template>
    <fragment>
        <section class="flat-slider style1 clearfix">
            <div class="rev_slider_wrapper fullwidthbanner-container">
                <div id="rev-slider1" class="rev_slider fullwidthabanner">
                    <ul>
                        <!-- Slide 1 -->
                        <li data-transition="random">
                            <!-- Main Image -->
                            <img src="/wwwroot/images/header/construction.jpg" alt="" data-bgposition="center center" data-no-retina>
                            <div class="overlay"></div>

                            <!-- Layers -->
                        </li>
                    </ul>
                </div>
            </div>
            <div class="apply-admission">
                <div class="apply-admission-wrap type2 bd-type1">
                    <div class="apply-admission-inner">
                        <h2 class="title text-center">
                            <span>Reset Password</span>
                        </h2>
                        <div class="caption text-center">
                            Please provide your new password
                         </div>
                        <div>
                            <div class="apply-sent apply-sent-style1" style="padding-top:40px">
                                <div class="form-sent-main">
                                    <input :class="{ 'not-valid': v_password }" v-model="password" type="password" placeholder="Enter your new password...">
                                </div>
                            </div>
                            <div class="apply-sent apply-sent-style1">
                                <div class="form-sent-main">
                                    <input :class="{ 'not-valid' : v_passwordRepeat }" v-model="passwordRepeat" type="password" placeholder="Repeat your new password ...">
                                </div>
                                <div style="text-align: center; margin-top: 25px">
                                    <button v-on:click="login" class="sign-up-main" href="#loader-modal" data-toggle="modal">Change password</button>
                                </div>
                            </div>
                            <br />
                            <div v-if="v_summary" class="alert alert-danger">
                                {{ v_summary }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section><!-- flat-slider -->
    </fragment>
</template>
<style scoped>
    .apply-admission {
        position: absolute;
        top: 25%;
        margin: 0;
        left: 15%;
        width: 70%;
        z-index: 100;
    }

    .apply-admission-wrap {
        padding-top: 20px !important;
        padding-bottom: 20px !important;
    }

    .register-link {
        color: white;
        text-decoration: underline;
        font-size: 20px;
    }

    .not-valid {
        border-color: rgb(255, 95, 96);
        border-width: 3px;
    }

    .alert-danger {
        background-color: rgb(255, 95, 96);
        border-color: rgb(255, 95, 96);
        color: white;
    }
</style>
<script>
    export default {
        name: 'Reset',
        computed: {
            resetToken() {
                return this.$route.params.id
            }
        },
        components: {
        },
        data: function () {
            return {
                password: "",
                passwordRepeat: "",

                v_password: false,
                v_passwordRepeat: false,
                v_summary: ""
            }
        },
        methods: {
            validate: function () {
                this.v_passwordRepeat = false;
                this.v_password = false;
                this.v_summary = null;

                if (!this.isNotEmpty(this.password)) {
                    this.v_summary = "Please enter a valid password with at least 6 characters";
                    this.v_password = true;
                    return false;
                }

                if (this.password != this.passwordRepeat) {
                    this.v_summary = "Passwords do not match";
                    this.v_passwordRepeat = true;
                    return false;
                }

                return true;
            },
            async login() {
                try {
                    if (this.validate()) {
                        var userState = await this.web('/auth/reset', "Resetting your password", {
                            resetToken: this.resetToken,
                            password: this.password
                        }, [400]);

                        //setting current user properties will log user in
                        this.$store.commit("setUserState", userState);
                        this.$router.replace("/dashboard");
                    }
                }
                catch (e) {
                    if (e.response.status == 400) {
                        this.v_summary = e.response.data;
                    }
                }
            }
        },
        mounted: function () {
            this.$store.commit("breadCrumbs", null);
          
        }
    };
</script>
